<template>
  <form name="scope" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-info-circle"></i> Informações gerais</h5>
    </div>
    <div class="row mb-4">
      <div class="col-md-2" v-if="data.id">
        <label>ID Escopo</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder
            v-model="data.id"
            readonly="readonly"
          />
        </div>
      </div>
      <div :class="{ 'col-md-5': data.id, 'col-md-7': !data.id }">
        <div class="form-group" :class="{ 'has-danger': !data.desc }">
          <label for="desc">
            Detalhe
            <span class="m--font-danger">*</span>
          </label>
          <div class="input-group">
            <input
              id="desc"
              type="text"
              ref="desc"
              class="form-control m-input"
              placeholder
              v-model="data.desc"
              required
            />
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name">
            HASH
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control m-input"
              name="name"
              id="name"
              placeholder
              v-model="data.name"
              readonly="readonly"
            />
          </div>
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.desc.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.desc"
          >
            O campo
            <strong>Detalhe</strong> é obrigatório *
          </a>
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'ScopeSaveForm',
  data() {
    return {
      doctype: 0,
      data: {},
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    saveForm() {
      this.messageWaitingSave();
      this.$refs.desc.focus();

      const { data } = this;

      const url = `${baseApiUrl}/v1/scope/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.data = data;
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/scope/data/${this.scopeId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
  },
  computed: {
    scopeId() {
      return this.$store.state.showScopeSave;
    },
    formIsValid() {
      if (this.data.desc) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.scopeId && this.scopeId !== 'add') {
      this.callData();
    }
  },
};
</script>

<style></style>
